import React from 'react';

const AWS_DDoS = () => {
  return (
    <div>
      <h1>AWS_DDoS</h1>
      <p>This is the AWS_DDoS component.</p>
    </div>
  );
};

export default AWS_DDoS;
